import { createContext, useState, ReactNode, Dispatch, SetStateAction, useEffect, useContext, useRef } from "react";
import { CustomFormField, SubmissionForm, submitValidator, ColTypeEntry } from "../services/interfaces";
import { UploadFileInfo } from "@progress/kendo-react-upload";

interface SubmissionContextType{
    adNumDisabled:boolean;
    setAdNumDisabled:Dispatch<SetStateAction<boolean>>;
    submitForm:SubmissionForm;
    setSubmitForm:Dispatch<SetStateAction<SubmissionForm>>;
    customFieldData:{ [key: number]: string };
    setCustomFieldData:Dispatch<SetStateAction<{ [key: number]: string }>>;
    submitValid:submitValidator;
    //setSubmitValid:Dispatch<SetStateAction<submitValidator>>;
    fields:CustomFormField[];
    setFields:Dispatch<SetStateAction<CustomFormField[]>>;
    files:UploadFileInfo[];
    setFiles:Dispatch<SetStateAction<UploadFileInfo[]>>;
    pkgData:any[];
    setPkgData:Dispatch<SetStateAction<any[]>>;
    setPickupWarning:Dispatch<SetStateAction<boolean>>;
    pickupWarning:Boolean;
}

export const SubmissionContext = createContext<SubmissionContextType | null>(null);

interface SubmissionContextProviderProps {
    children: ReactNode;
}


export function SubmissionContextProvider({children}: SubmissionContextProviderProps){
    const [fields, setFields] = useState<CustomFormField[]>([]);
    const [customFieldData, setCustomFieldData]=useState<{ [key: number]: string }>({});
    const [files, setFiles]=useState<Array<UploadFileInfo>>([]);
    const [adNumDisabled, setAdNumDisabled]=useState(true);
    const [pkgData, setPkgData] = useState<any[]>([]);
    const [pickupWarning,setPickupWarning]=useState(false);
    const [submitForm, setSubmitForm]= useState<SubmissionForm>(
        {
            subType:"",
            adType:{ text: "", value: "" },
            element:"",
            site:{code:"",
                name:"",
                logo_Prefix:"",
                primary_ip:"",
                backup_ip:"",
                temp_Char:"",
                temp_Int:0,
                vol1_Unc_Path:"",
                vol2_Unc_Path:""},
            extension:"",
            slug:"",
            customer:{customer:'',fileSize2:'',file1:''},
            account:"",
            salesRep:{customer:"", displayName:"",security:1,temp4:"",fullName:""},
            color:{text:"", value:""},
            category: {} as ColTypeEntry,
            pickup:"",
            tagline:"",
            comment:"",
            deadlineType:{ text: "", value: "" },
            size:[],
            date:[],
            prCheck:false,
            prConfirm:{value:"",label:""},
            allFilesIn:false,
            multiPage:false,
            copyCampaign:false,
            noFiles:false,
            setStatus:"",
            zone0:"",
            path:"",
            timeStamp:0,
            source:"",
            multiPickup:false,
            ticket:"",
            custom:[],
            submissionEmail:"",
            correctionEmail:"",
            annotations:[],
            isHold:false,
            instructionsNotFollowed:false,
            additionalCorrections:false,
            siteFlag:"",
            useClipper:false,
            pickupWithChanges:false,
            adCopy:"",
            instructions:"",
            hasAnnotations:false,
            pickupExpire:{ text: "Change to Date of Book", value: "BOOK" },
            pickupExpireDate: null,
            addWatch:false,
            fileList: [{ type: "", fileName: "", size: 0, extension: "", status:"" }],
            runDates:[],
            trigger:"",
            noteColor:""
        }
    );

    // const [submitValid, setSubmitValid] = useState<submitValidator>({
    //     pickup: false,
    //     proof: false,
    //     basic: false,
    //     custom: false,
    //     file: true,
    //     hold: true,
    //     instructions: true,
    // });

    var submitValid = useRef<submitValidator>({
        pickup: false,
        proof: false,
        basic: false,
        custom: false,
        file: true,
        hold: true,
        sizes:false,
        dates:false,
        instructions: true,
    }).current;

    return (
            <SubmissionContext.Provider value={{adNumDisabled,setAdNumDisabled,submitForm,setSubmitForm, customFieldData, setCustomFieldData, submitValid, fields, setFields, files, setFiles, pkgData,setPkgData, setPickupWarning,pickupWarning}}>
                {children}
            </SubmissionContext.Provider>
        );
}